import { TileItemRelationsFragment } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import { ArrayElementType } from '@/integrations/crystallize/types/helpers/ArrayElementType';

export function extractColors(
  selectedProduct: ArrayElementType<TileItemRelationsFragment['items']>,
) {
  // Using a map to ensure uniqueness of color names
  const colorsMap: Map<string, { name: string; hexCode: string; variantIndex: number }> = new Map();
  const variantsContent =
    selectedProduct.__typename === 'Product' ? selectedProduct.variants : undefined;
  variantsContent?.forEach((variant, index: number) => {
    const colorOptions =
      variant.color?.content?.__typename === 'SelectionContent'
        ? variant.color.content.options
        : undefined;

    if (colorOptions && colorOptions?.length > 0) {
      const colorName = colorOptions[0].key;
      const colorHex = colorOptions[0].value;

      if (colorName && colorHex) {
        // Check if color name already exists in the map
        if (!colorsMap.has(colorName)) {
          colorsMap.set(colorName, {
            name: colorName,
            hexCode: colorHex,
            variantIndex: index,
          });
        }
      }
    }
  });

  // Convert the map to an array of color objects
  const colorsArray = Array.from(colorsMap.values());

  return colorsArray;
}
